/* eslint-disable max-lines-per-function */
/* eslint-disable no-param-reassign */
import { Toolbar } from 'primereact/toolbar'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { useEffect } from 'react'
import { InputText } from 'primereact/inputtext'
import { Calendar } from 'primereact/calendar'
import { useSelector } from 'react-redux'
import Table from '../../../components/layout/Table'
import cauHinhBanChinhProcessor from '../../../processor/cauHinhBanChinhProcessor'
import { dateToDDMMYY, DDMMYYToDate } from '../../../utils/date'

const ThayDoiCauHinhBanChinh = (props) => {
  const modeTitle = 'Thay đổi cấu hình bản chính'
  const toast = useSelector((store) => store.notify.toast)
  const { namId, setNamId, khoaThiId, setKhoaThiId, datas, setDatas, listNam, listKhoaThi } = props
  const column = [
    { value: 'name', name: 'Tên', sortable: true, width: '50%' },
    {
      name: 'Giá trị',
      width: '50%',
      render: (data) => {
        return (
          <>
            {data.code === 'NguoiKy' ? (
              <InputText
                value={data.value}
                onChange={(event) => {
                  data.value = event.target.value
                  setDatas([...datas])
                }}
              />
            ) : (
              <Calendar
                showButtonBar
                dateFormat="dd/mm/yy"
                value={DDMMYYToDate(data.value)}
                onChange={(event) => {
                  if (event.target.value) {
                    data.value = dateToDDMMYY(event.target.value)
                    setDatas([...datas])
                  }
                }}
              />
            )}
          </>
        )
      },
    },
  ]

  const getDanhSachBanChinh = async () => {
    if (khoaThiId) {
      const rs = await cauHinhBanChinhProcessor.getByKhoaThi(khoaThiId)
      setDatas(rs)
    }
  }

  useEffect(getDanhSachBanChinh, [khoaThiId])

  const save = async () => {
    const rs = await cauHinhBanChinhProcessor.updateMany(
      datas.map((data) => {
        return { ...data, khoaThiId }
      }),
    )
    if (!rs.isSuccess) {
      await getDanhSachBanChinh()
    }
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
  }
  return (
    <>
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>{modeTitle}</h4>
          <div>
            <Button icon="pi pi-save" className="p-button-success" onClick={save} label="Lưu" />
          </div>
        </div>
        <div className="card">
          <Toolbar
            className="mb-4"
            right={
              <div className="flex">
                <Dropdown
                  className="mr-2"
                  optionLabel="name"
                  optionValue="id"
                  options={listNam}
                  value={namId}
                  onChange={(e) => {
                    setNamId(e.value)
                  }}
                  filter
                  filterBy="name"
                />
                <Dropdown
                  optionLabel="date"
                  optionValue="id"
                  options={listKhoaThi}
                  value={khoaThiId}
                  onChange={(e) => {
                    setKhoaThiId(e.value)
                  }}
                  filter
                  filterBy="date"
                />
              </div>
            }
          />
          <Table data={datas} column={column} paginator={false} />
        </div>
      </div>
    </>
  )
}

export default ThayDoiCauHinhBanChinh
